import { isEmpty } from '@jfs/utils'

export const InstrumentsParser = (response: any) => {
  const retData: any = []
  const modes: any = []
  const getMappedValue: any = {
    'INSTANT DISCOUNT': 'Instant Discount',
    CAHSBACK: 'Cashback',
    VISA: 'VISA',
    MASTER: 'MASTER',
    AMEX: 'AMEX',
    FIXED: 'Fixed',
    PERCENTAGE: 'Percentage',
  }
  const parser = (data: any) => {
    return data.map((item: any) => {
      return {
        id: item.key,
        value: getMappedValue[item?.value] ?? item?.value,
        tenures: item?.tenures ?? [],
      }
    })
  }

  const getValue: any = {
    cardScheme: 'Card',
    wallet: 'Wallet',
    offerType: 'rewardType',
    unitType: 'unitType',
    bankId: 'bankId',
    bank: 'Bank',
    status: 'status',
    bankEmiId: 'bankEmiId',
    emiTenure: 'emiTenure',
  }

  const getModeValue: any = {
    cardScheme: 'Card',
    wallet: 'Wallet',
    bank: 'NetBanking',
  }

  const setModes = (key: any, index: number) => {
    const mode = { id: `${index}`, value: getModeValue[key], selected: false }
    !isEmpty(getModeValue[key]) && modes.push(mode)
  }

  const setInstruments = (item, index) => {
    const retItem = {
      id: `${index}`,
      type: isEmpty(item?.keySubType) ? getValue[item.mappingKey] : getValue[item?.keySubType],
      subType: item?.keySubType,
      values: parser(item.values),
    }
    !isEmpty(getValue[item.mappingKey]) && retData.push(retItem)
  }
  response?.data?.masterList?.map((item: any, index: number) => {
    const key = isEmpty(item?.keySubType) ? item.mappingKey : item?.keySubType
    setModes(key, index)
    setInstruments(item, index)
  })
  return { instruments: retData, modes: modes }
}
